import { EnableSidebar, PageTitle } from '../../../_metronic/layout/core'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { ChartsWidgetGeneral, ChartsWidgetGeneralBar } from '../../../_metronic/partials/widgets'
import { Vertical } from '../../modules/wizards/components/Vertical';
import { getApplicationRole as getApplicationRole } from '../applicationrole/list/core/_requests'
import { customGetBankInfo } from '../applicationuser/list/core/_requests'
import "./Hide.css"
import BankInfoPopup from './BankInfo';
import VideoPlayer from './VideoPlayer';

const DashboardPage = () => {
    const intl = useIntl()
    const [organizations, setorganizations] = React.useState([])
    const [organizations2, setorganizations2] = React.useState<Array<number>>([])
    const [organizations3, setorganizations3] = React.useState<Array<string>>([])
    const [surveytypes, setsurveytypes] = React.useState([])
    const [semesters, setsemesters] = React.useState([])
    const [applicationroles, setapplicationroles] = React.useState([])

    const [bankInfo, setBankInfo] = React.useState("1")
    //document?.getElementById("kt_header")?.classList.add("hide");

    useEffect(() => {        
        getApplicationRole("items_per_page=99999", "Id,Name,ApplicationUserRole*ApplicationRoleId", "ApplicationUserRole").then((res: any) => {
            setapplicationroles(res.data.map((a: any) => { return { value: a?.applicationUserRoleApplicationRoleId.length, label: a?.name } }) || [])
        })

        customGetBankInfo().then((a: any) => {
            setBankInfo(a)
        })
    }, [])

    useEffect(() => {
        console.log(bankInfo)
    }, [bankInfo])

    useEffect(() => {
        setorganizations2(organizations.map((a: any) => a.value))
        setorganizations3(organizations.map((a: any) => a.label))
    }, [organizations])



    return (

        <>
            <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
            <VideoPlayer />
            <div className='soru'>
                <a className="btn btn-primary" href="https://sysapi.ege.edu.tr/Files/KKTC_soru_yazim_kilavuzu.pdf" target="_blank" rel="noreferrer">Soru Yazım Kuralları</a>
                {/*<p><strong>Sorularda Olması Beklenen Özellikler</strong></p>*/}
                {/*<ol>*/}
                {/*    <li>Soru yeni, özgün olmalı.</li>*/}
                {/*    <li>Sorular çok kolay ya da sıradan olmamalı, mümkün olduğunca seçici olmalı.</li>*/}
                {/*    <li>Soru kökü anlamlı olmalı, gereksiz yere uzatılmış olmamalı.</li>*/}
                {/*    <li>Soru kökünde olumsuz (değildir, olmaz vs.) ya da enli (ez az, en çok vs.) ifade var ise altı çizilmeli.</li>*/}
                {/*    <li>Soru kökü kalın (bold) olarak ayarlanmalı.</li>*/}
                {/*    <li>Her bir sorunun seçenekler uzunlukları birbirlerine yakın olmalı.</li>*/}
                {/*    <li>Soruların yanıtları girilirken, doğru yanıt en üstteki doğru yanıt alanına girilmeli. Diğer şıklar aşağıdaki diğer şıklar alanına girilmeli.</li>*/}
                {/*    <li>Sorular 5 seçenekli olmalı ve seçeneklerden “hepsi” ve “hiçbiri” seçenek olarak kullanılmamalı.</li>*/}
                {/*    <li>Seçeneklerde birbirinin zıttı ifadeler olmamalı.</li>*/}
                {/*    <li>Seçeneklerde aynı ifade tekrarı olmamalı.</li>*/}
                {/*    <li>Sorular yurtdışında kullanılacağından TC mevzuatı ve Türkiye örneği içermemeli.</li>*/}
                {/*    <li>Hesaplama gerektiren sorular; sınavlarda hesap makinası kullanılmasına izin verilmediğinden, hesap makinası kullanılmayacak nitelikte olmalı.</li>*/}
                {/*    <li>Soru veya şıklarda kullanılacak resimlerin renkli olmaması.</li>*/}
                {/*    <li>Soru metninde kullanılacak resimlerin genişlikleri 7 cm.’yi geçmemeli.</li>*/}
                {/*    <li>Kullanılacak resimlerin çözünürlüğü ve netliği yüksek olmalı.</li>*/}
                {/*    <li>Soru metninde kullanılacak madde imleri için büyük roma rakamları kullanılmalı (I-II-III-IV vb.).</li>*/}
                {/*    <li>Soru paketinde birbirleri ile aynı şıklara sahip sorular olmamalı.</li>*/}
                {/*    <li>Soru metninde veya şıklarda kavram yanılgısına neden olabilecek kelimelerin İngilizceleri parantez içerisinde verilmeli.</li>*/}
                {/*</ol>*/}
                {/*<p><strong>Not:</strong> Sorular Merkezimizde özgünlük, doğruluk ve yukarıda belirtilen özellikler bakımından denetlenmektedir. Uygun olmayan sorular kabul edilmeyebilir, yerine yeni soru ya da düzeltme istenebilir.</p>*/}
            </div>
            {bankInfo === "0" && <BankInfoPopup /> }
            {/* <div className='row'>
                {surveytypes.length > 0 && (surveytypes.map((a: any) => a.value).length > 10 ?
                    <div className='mb-7 col-12'>
                    <ChartsWidgetGeneralBar className="1" title={intl.formatMessage({ id: 'SurveyType.STATS' })} series={surveytypes.map((a: any) => a.value)} labels={surveytypes.map((a: any) => a.label)} name='Survey.COUNT' />
                </div>
                    : <div className='mb-7 col-4'>
                    <ChartsWidgetGeneral className="1" title={intl.formatMessage({ id: 'SurveyType.STATS' })} series={surveytypes.map((a: any) => a.value)} labels={surveytypes.map((a: any) => a.label)} />
                </div>
                )}
                {applicationroles.length > 0 && (
                    applicationroles.map((a: any) => a.value).length > 10 ?
                        <div className='mb-7 col-12'>
                            <ChartsWidgetGeneralBar className="2" title={intl.formatMessage({ id: 'ApplicationRole.STATS' })} series={applicationroles.map((a: any) => a.value)} labels={applicationroles.map((a: any) => a.label)} name='ApplicationUserRole.COUNT' />
                        </div>
                        : <div className='mb-7 col-4'>
                            <ChartsWidgetGeneral className="2" title={intl.formatMessage({ id: 'ApplicationRole.STATS' })} series={applicationroles.map((a: any) => a.value)} labels={applicationroles.map((a: any) => a.label)} />
                        </div>
                )}
                {semesters.length > 0 && (semesters.map((a: any) => a.value).length > 10 ?
                    <div className='mb-7 col-12'>
                        <ChartsWidgetGeneralBar className="" title={intl.formatMessage({ id: 'Semester.STATS' })} series={semesters.map((a: any) => a.value)} labels={semesters.map((a: any) => a.label)} name='SemesterCourse.COUNT' />
                    </div>
                    : <div className='mb-7 col-4'>
                        <ChartsWidgetGeneral className="" title={intl.formatMessage({ id: 'Semester.STATS' })} series={semesters.map((a: any) => a.value)} labels={semesters.map((a: any) => a.label)} />
                    </div>
                )}
                {organizations2.length > 0 && organizations3.length > 0 && (organizations.map((a: any) => a.value).length > 10 ?
                    <div className='mb-7 col-12'>
                        <ChartsWidgetGeneralBar className="3" title={intl.formatMessage({ id: 'Organization.Student.STATS' })} series={organizations2} labels={organizations3} name='Student.COUNT' />
                    </div>
                    : organizations2 && organizations3 && <div className={`mb-7 col-4 ${organizations.map((a: any) => a.value).length}`}>
                    <ChartsWidgetGeneral className="3" title={intl.formatMessage({ id: 'Organization.Student.STATS' })} series={organizations2} labels={organizations3} />
                </div>)
                }
            </div>*/}
        </>
    )
}

const DashboardWrapper = () => {
  return (
    <EnableSidebar>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
          <div className='card-xl-stretch mb-5 mb-xl-10'>
        <Vertical />
      </div>
     
    </EnableSidebar>
  )
}

export {DashboardPage}
